<template>
  <v-card v-if="show" class="chatbox">
    <v-card-title class="chatbox-header">
      <span>New Message</span>
      <v-btn icon @click="closeBox">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="chatbox-body">
      <v-autocomplete
        v-model="selected"
        :items="recipientList"
        item-text="name"
        item-value="userId"
        outlined
        dense
        hide-details
        :menu-props="{ maxHeight: '140px', offsetY: true, attach: false }"
        label="Select recipient"
        @change="onRecipientChange"
      >
        <template #item="{ item }">
          <div class="d-flex align-center" style="max-width: 210px;">
            <v-avatar size="24" class="mr-2">{{ item.initials }}</v-avatar>
            <span style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{ item.name }}</span>
          </div>
        </template>
      </v-autocomplete>

      <v-textarea
        v-model="msg"
        outlined
        label="Write a message..."
        rows="3"
        hide-details
        class="custom-textarea"
        @keydown.enter="handleKeyPress"
      ></v-textarea>

      <v-btn block :color="primaryColor" class="white--text" @click="sendMessage">
        Send
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import chatService from "@/services/chatService";
import partyService from "@/services/partyService";
import colors from "../../constants/colors";

export default {
  name: "ChatBox",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      recipientList: [], 
      selected: null, 
      msg: "",
      primaryColor: colors.BRAND_PRIMARY_COLOR_3,
    };
  },
  methods: {
    async init() {
      this.recipientList = await partyService.getChatParties();

      this.recipientList = this.recipientList.map(party => ({
        id: party.id,
        name: party.name,
        initials: this.getInitials(party.name),
        userId: party.userId,
        connectedCompanyCode: party.connectedCompanyCode,
      }));
    },
    getInitials(name) {
      if (name === "")
        return "";

      return name
          .match(/\b(\w)/g)
          .join("")
          .substring(0, 2)
          .toUpperCase();
    },
    closeBox() {
      this.$emit("close");
    },
    async handleKeyPress(event) {
      // Add newline on Shift+Enter otherwise send message
      if (!event.shiftKey) {
        event.preventDefault();
        await this.sendMessage();
      }
    },
    async sendMessage() {
      if (!this.msg || this.selected === null) {
        this.$root.$snackbar.message("Please select at least one recipient and write a message.");
        return;
      }
      
      try {
        const toParty = this.recipientList.find((r) => r.userId === this.selected);
        if (toParty) {
          let channelUrl = await chatService.sendMessage(toParty, this.msg);
          this.$emit('message-sent', channelUrl);
          this.msg = "";
          this.selected = null;
        } else {
          this.$root.$snackbar.error("Failed to send the message. Please try again.");
        }
      } catch (error) {
        this.$root.$snackbar.error("Failed to send the message. Please try again.");
      }
    },
    onRecipientChange(){
      let selected = this.recipientList.find(x => x.userId == this.selected);
      this.$emit('recipient-changed', selected);
    }
  },
  watch: {
    show() {
      if (!this.show) this.selected = null;
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.chatbox {
  position: fixed;
  bottom: 20px;
  right: 370px;
  width: 300px;
  z-index: 2000;
}

.chatbox-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1em;
  padding-bottom: 10px;
}

.chatbox-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.custom-textarea /deep/ textarea {
  font-size: small;
  line-height: 1.1rem;
}
</style>